import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const CityPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.City}
        fetchRecordsUrl={AdminReqUrls.admin__city__mainPage_fetch_recordList}
    />)
});
export default CityPage;
